import React from 'react';
export function TestimonialsSection() {
  return <section className="py-20 px-5 bg-cream text-center reveal" data-id="element-286">
      <h2 className="font-playfair text-[clamp(1.8rem,3.5vw,2.6rem)] font-bold text-text-dark mb-3.5 leading-[1.2]" data-id="element-287">
        Lo que dicen otras mamás
      </h2>
      <p className="font-lora text-base text-text-mid max-w-[500px] mx-auto mb-10 leading-relaxed italic" data-id="element-288">
        Resultados reales de familias que aplicaron el sistema.
      </p>

      {/* Kids using the product image */}
      <div className="max-w-[680px] mx-auto mb-10 rounded-2xl overflow-hidden shadow-[0_8px_32px_rgba(30,45,36,0.12)]" data-id="element-289">
        <img src="https://cdn.magicpatterns.com/uploads/poyCSKnWXnk3oL2yTSxw1U/Green_Brown_Natural_Photo_Collage_Family_Canvas.png" alt="Niños usando el programa de activación lectora" className="w-full block" data-id="element-290" />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-[860px] mx-auto mb-10" data-id="element-291">
        {/* Testimonial 1 */}
        <div className="bg-white rounded-xl py-7 px-6 text-left shadow-[0_2px_16px_rgba(30,45,36,0.06)] border-b-[3px] border-b-cream-dark transition-all duration-200 hover:-translate-y-1 hover:border-b-forest" data-id="element-292">
          <div className="text-terracotta text-base mb-3 tracking-[2px]" data-id="element-293">
            ★★★★★
          </div>
          <p className="font-lora text-[0.9rem] text-text-mid leading-[1.7] italic mb-4" data-id="element-294">
            "Nunca pensé verlo disfrutar tanto al aprender a leer. Antes era una
            batalla campal, ahora él mismo trae sus hojas de trabajo."
          </p>
          <div data-id="element-295">
            <strong className="block text-[0.88rem] text-text-dark font-sans" data-id="element-296">
              Carolina M.
            </strong>
            <span className="text-[0.78rem] text-text-light" data-id="element-297">
              Mamá de Tomás, 6 años
            </span>
          </div>
        </div>

        {/* Testimonial 2 */}
        <div className="bg-white rounded-xl py-7 px-6 text-left shadow-[0_2px_16px_rgba(30,45,36,0.06)] border-b-[3px] border-b-cream-dark transition-all duration-200 hover:-translate-y-1 hover:border-b-forest" data-id="element-298">
          <div className="text-terracotta text-base mb-3 tracking-[2px]" data-id="element-299">
            ★★★★★
          </div>
          <p className="font-lora text-[0.9rem] text-text-mid leading-[1.7] italic mb-4" data-id="element-300">
            "En dos semanas ya reconocía sílabas que le costaban meses en el
            colegio. Estamos felices y él se siente un superhéroe."
          </p>
          <div data-id="element-301">
            <strong className="block text-[0.88rem] text-text-dark font-sans" data-id="element-302">
              Valeria S.
            </strong>
            <span className="text-[0.78rem] text-text-light" data-id="element-303">
              Mamá de Sofi, 5 años
            </span>
          </div>
        </div>

        {/* Testimonial 3 */}
        <div className="bg-white rounded-xl py-7 px-6 text-left shadow-[0_2px_16px_rgba(30,45,36,0.06)] border-b-[3px] border-b-cream-dark transition-all duration-200 hover:-translate-y-1 hover:border-b-forest" data-id="element-304">
          <div className="text-terracotta text-base mb-3 tracking-[2px]" data-id="element-305">
            ★★★★★
          </div>
          <p className="font-lora text-[0.9rem] text-text-mid leading-[1.7] italic mb-4" data-id="element-306">
            "Está más confiado y se anima a formar sus primeras palabras sin
            miedo a equivocarse. El cambio de actitud es lo que más valoro."
          </p>
          <div data-id="element-307">
            <strong className="block text-[0.88rem] text-text-dark font-sans" data-id="element-308">
              Andrea P.
            </strong>
            <span className="text-[0.78rem] text-text-light" data-id="element-309">
              Mamá de Lucas, 7 años
            </span>
          </div>
        </div>

        {/* Testimonial 4 */}
        <div className="bg-white rounded-xl py-7 px-6 text-left shadow-[0_2px_16px_rgba(30,45,36,0.06)] border-b-[3px] border-b-cream-dark transition-all duration-200 hover:-translate-y-1 hover:border-b-forest" data-id="element-310">
          <div className="text-terracotta text-base mb-3 tracking-[2px]" data-id="element-311">
            ★★★★★
          </div>
          <p className="font-lora text-[0.9rem] text-text-mid leading-[1.7] italic mb-4" data-id="element-312">
            "Pasamos de peleas y llantos a que él me pida hacer los juegos de
            las letras. Increíble el cambio en tan poco tiempo."
          </p>
          <div data-id="element-313">
            <strong className="block text-[0.88rem] text-text-dark font-sans" data-id="element-314">
              Mariana G.
            </strong>
            <span className="text-[0.78rem] text-text-light" data-id="element-315">
              Mamá de Benja, 6 años
            </span>
          </div>
        </div>
      </div>

      <p className="text-[0.78rem] text-text-light italic mt-1.5 mb-8" data-id="element-316"></p>

      <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWN9M59KdNNduHrWqQMttkBd/es-ar?_r=AQABgGschoRR_SY96W8jodDFHW8nWvDOxXINeW34G_-0IYY&preview_theme_id=163059597347" target="_blank" rel="noopener noreferrer" className="inline-block bg-terracotta text-white font-sans text-[0.95rem] font-medium tracking-[0.06em] uppercase py-[18px] px-10 rounded text-decoration-none border-none cursor-pointer transition-all duration-200 hover:bg-terracotta-light hover:-translate-y-0.5" data-id="element-317">
        Quiero ver estos resultados →
      </a>
    </section>;
}